import React from 'react';

import style from './Footer.module.css';

const Footer = React.memo(() => {
  return (
    <footer className={style.footer}>
      <section className={style.availability}>
        <span className={style.phone}>Call (888) 960-3926</span>
        <span>8 a.m. - 5:30 p.m. CT Monday - Friday</span>
        <span className={style.separator}>|</span>
        <span className={style.email}>SPG_smarthubservice@specialtyprogramgroup.com</span>
      </section>
      <section className={style.copyright}>
        <div className={`container ${style.container}`}>
          <div className="row">
            <p className={style.text}>
              © {new Date().getFullYear()} Insureon, a Division of Specialty
              Program Group LLC / DBA SPG Insurance Solutions ALL RIGHTS
              RESERVED (CA License #0L09546). All other trademarks and
              copyrights are property of their respective owners. 203 N. LaSalle
              St. 20th Floor, Chicago, IL 60601. SPG_smarthubservice@specialtyprogramgroup.com
              (888)-960-3926
            </p>
          </div>
        </div>
      </section>
    </footer>
  );
});

export default Footer;
